import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "icon/navigation/close_24px",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "icon/navigation/close_24px_2",
				d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0",
				"mask-type": "alpha",
				maskUnits: "userSpaceOnUse",
				x: 5,
				y: 5,
				width: 14,
				height: 14,
				children: /* @__PURE__ */ _jsx("path", {
					id: "icon/navigation/close_24px_3",
					d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
		]
	})]
});
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
